import { cn } from '#src/styling/cn.ts';
import { Popover as Primitive } from 'radix-ui';
import type { ComponentProps, ComponentPropsWithoutRef } from 'react';

export type PopoverRootProps = ComponentProps<typeof Primitive.Root>;

const PopoverRoot = (props: PopoverRootProps) => {
  return <Primitive.Root data-slot="popover" {...props} />;
};

export type PopoverTriggerProps = ComponentProps<typeof Primitive.Trigger>;

const PopoverTrigger = (props: PopoverTriggerProps) => {
  return <Primitive.Trigger data-slot="popover-trigger" {...props} />;
};

export type PopoverContentProps = ComponentPropsWithoutRef<typeof Primitive.Content>;

const PopoverContent = ({
  className,
  align = 'center',
  sideOffset = 4,
  ...props
}: PopoverContentProps) => (
  <Primitive.Portal>
    <Primitive.Content
      data-slot="popover-content"
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-sm border border-gray-300 p-4 shadow-lg outline-hidden',
        className,
      )}
      {...props}
    />
  </Primitive.Portal>
);

export const Popover = {
  Root: PopoverRoot,
  Trigger: PopoverTrigger,
  Content: PopoverContent,
};
